// extracted by mini-css-extract-plugin
export default {"wrapperTurkishVipHavale":"VipHavale_wrapperTurkishVipHavale__3wehI","checkbox":"VipHavale_checkbox__2aMJ3"};